import { render, staticRenderFns } from "./GestionUsuarios.vue?vue&type=template&id=5f8606c7&scoped=true"
import script from "./GestionUsuarios.vue?vue&type=script&lang=js"
export * from "./GestionUsuarios.vue?vue&type=script&lang=js"
import style0 from "./GestionUsuarios.vue?vue&type=style&index=0&id=5f8606c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8606c7",
  null
  
)

export default component.exports